export default __webpack_public_path__ + "static/media/logo.259ddfb8.png";